import { parseISO, format, formatDistance, formatRelative, subDays } from "date-fns"

export const formatTimestamp = (dateString) => {
  return format(parseISO(dateString), 'LL/dd/yy');
}